export default __webpack_public_path__ + "static/media/elissa.06ad9bff.jpg";